export enum CountryCode {
  CL = 'CL',
}
